
<div (click)="open()" class=" full-content margin-1-rem col-12">
  <img [src]="url" *ngIf="url && !isVideo">
  <video [src]="url" *ngIf="url && isVideo"></video>
</div>
